<script>
  import Landing from "./components/Landing.svelte";
  import Publication from "./components/Publication.svelte";
  import Authors from "./components/Authors.svelte";
  import Download from "./components/Download.svelte";
  import Footer from "./components/Footer.svelte";
  import Nav from "./components/Nav.svelte";
</script>

<main>
    <Nav/>
    <Landing/>
    <Publication/>
    <Authors/>
    <Download/>
    <Footer/>
</main>

<style>
</style>
